export const SET_PRE_DEALS = 'SET_PRE_DEALS';
export const SET_IS_FETCHING_PRE_DEALS = 'SET_IS_FETCHING_PRE_DEALS';
export const SET_IS_DOWNLOAD_PRE_DEALS = 'SET_IS_DOWNLOAD_PRE_DEALS';
export const SET_PRE_DEAL = 'SET_PRE_DEAL';
export const SET_CURRENT_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
